import React, { useEffect, useState } from "react";
import QuickBoostForm from "./QuickBoostForm";
import { fetchAllQuickBoosts, deleteQuickBoost } from "./adminQuickBoostService";
import "../../blog/tongueTwister.css";

const AdminQuickBoostPage = () => {
 const [items, setItems] = useState([]);
 const [editing, setEditing] = useState(null);
 const [showForm, setShowForm] = useState(false);
 const [loading, setLoading] = useState(false);
 const [page, setPage] = useState(0);
 const [totalPages, setTotalPages] = useState(0);

 useEffect(() => {
 loadItems();
 }, [page]);

 const loadItems = async () => {
 setLoading(true);
 const res = await fetchAllQuickBoosts({ page, size: 20 });
 if (res.status === 200 && res.data) {
 const list = res.data.content || res.data.data || [];
 setItems(list);
 setTotalPages(res.data.totalPages || 0);
 } else {
 setItems([]);
 alert(res.message || "Failed to load data");
 }
 setLoading(false);
 };

 const handleDelete = async (id) => {
 if (!window.confirm("Delete this quick boost?")) return;
 const res = await deleteQuickBoost(id);
 if (res.status === 200 || res.status === 204) {
 loadItems();
 } else {
 alert(res.message);
 }
 };

 const onSaved = () => {
 setShowForm(false);
 setEditing(null);
 loadItems();
 };

 return (
 <div className="admin-container">
 <div className="admin-header">
 <h2>Quick Boost Management</h2>
 <button
 onClick={() => {
 setEditing(null);
 setShowForm(true);
 }}
 >
 + New Quick Boost
 </button>
 </div>

 {showForm && (
 <QuickBoostForm
 data={editing}
 onSaved={onSaved}
 onCancel={() => setShowForm(false)}
 />
 )}

 {loading ? (
 <p>Loading...</p>
 ) : (
 <table className="announcement-table">
 <thead>
 <tr>
 <th>Title</th>
 <th>YouTube</th>
 <th>Actions</th>
 </tr>
 </thead>
 <tbody>
 {items.length === 0 ? (
 <tr>
 <td colSpan="3">No data found</td>
 </tr>
 ) : (
 items.map((t) => (
 <tr key={t.id}>
 <td>{t.title}</td>
 <td>
 {t.youtubeLink ? (
 <a href={t.youtubeLink} target="_blank" rel="noreferrer">
 Link
 </a>
 ) : (
 "—"
 )}
 </td>
 <td>
 <button
 onClick={() => {
 setEditing(t);
 setShowForm(true);
 }}
 >
 Edit
 </button>
 <button
 className="delete-btn"
 onClick={() => handleDelete(t.id)}
 >
 Delete
 </button>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}

 {totalPages > 1 && (
 <div style={{ marginTop: 20 }}>
 <button disabled={page === 0} onClick={() => setPage(page - 1)}>
 Prev
 </button>
 <span style={{ margin: "0 10px" }}>
 Page {page + 1} / {totalPages}
 </span>
 <button
 disabled={page + 1 >= totalPages}
 onClick={() => setPage(page + 1)}
 >
 Next
 </button>
 </div>
 )}
 </div>
 );
};

export default AdminQuickBoostPage;
